import { inject, provideAppInitializer } from '@angular/core';

import { AuthSessionService } from '../../features/auth/services/auth-session.service';

export function provideAuth() {
  return provideAppInitializer(() => inject(AuthSessionService).bootstrap());
}
